export default theme => ({
	root: {},
	form: {
		//display: 'flex',
		//flexWrap: 'wrap'
	},
	group: {
		flexGrow: 1,
		padding: theme.spacing(2)
	},
	groupLabel: {
		paddingLeft: theme.spacing(2)
	},
	field: {
		marginBottom: theme.spacing(2),
		marginTop: theme.spacing(2),
		display: 'flex',
		alignItems: 'center'
	},
	textField: {
		width: '100%',
		marginBottom: theme.spacing(2)
	},
	portletFooter: {
		paddingLeft: theme.spacing(3),
		paddingRight: theme.spacing(3),
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2)
	},
	formControl: {
		//margin: theme.spacing.unit * 2,
		minWidth: 120,
		width: '100%',
	},
	textFieldSelect: {
		width: '100%',
		marginBottom: theme.spacing(2)
	},
	message: {
		display: 'flex',
		alignItems: 'center',
		fontSize: 20,
		wordWrap: "break-word",
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: "normal",
		width:'500px'
	},
	icon: {
		fontSize: 20,
	},
	iconVariant: {
		opacity: 0.9,
		marginRight: theme.spacing(2),
	},
	snackContent: {
		backgroundColor: theme.palette.error.dark,
	},
	snackContentOk: {
		backgroundColor: theme.palette.success.main,
	},
	modal: {
		maxHeight: '100%',
		//position: 'relative',
		//top: '50%',
		
		transform: 'translate(0, 20%)',
		overflowY: 'auto',
		//padding: theme.spacing(2, 4, 3),
		boxShadow: theme.shadows[5],
		backgroundColor: 'white',
		border: '2px solid #000',
		//width: '75vw',
		/*[theme.breakpoints.between('sm', 'lg')]: {
			width: '75vw',
		},
		[theme.breakpoints.down('sm')]: {
			width: '100vw',
		},*/
	},
	modalDeleted: {
		maxHeight: '100%',
		//position: 'relative',
		//top: '50%',
		
		transform: 'translate(0, 50%)',
		overflowY: 'auto',
		//padding: theme.spacing(2, 4, 3),
		boxShadow: theme.shadows[5],
		backgroundColor: 'white',
		border: '2px solid #000',
		//width: '75vw',
		/*[theme.breakpoints.between('sm', 'lg')]: {
			width: '75vw',
		},
		[theme.breakpoints.down('sm')]: {
			width: '100vw',
		},*/
	},
	buttonClosed:{
		textAlign:"right",
		color:'white'
	}
});
